import Flickity from 'flickity-imagesloaded';
import Choices from 'choices.js';

export default(() => {

    const carousel = document.querySelector('.member-options-carousel__carousel');
    const mainContainer = document.querySelector('.member-options-carousel');
    const allOptions = [];
    let updateVisibleOptions;
    let selectedOptions;
    let flkty;

    if (carousel) {

        const slides = Array.from(document.querySelectorAll('.member-options-carousel__slide-wrap'));
        const expandBtns = Array.from(document.querySelectorAll('.member-options-carousel .js-toggle'));
        const carouselVisibleClass = 'member-options-carousel--visible';
        const slideVisibleClass = 'member-options-carousel__slide-wrap--visible';
        const selectedClass = 'is-selected';
        const fullHeightClass = 'member-options-carousel__slide-full-height';


        const optionsTypeDropdown = document.querySelector('#optionsTypeSelect');
        const choicesOptionsDropdown = new Choices(optionsTypeDropdown, {
            searchEnabled: false,
            placeholder: false,
            itemSelectText: '',
            choices: [
                { value: 'recommended', label: 'Recommended', selected: true },
                { value: 'all', label: 'All' },
            ],
        });

        const getAllOptions = () => {
            slides.forEach((slide) => {
                allOptions.push(parseInt(slide.getAttribute('data-level'), 10));
            });
        };

        const getRecommendedOptions = () => {
            selectedOptions = carousel.getAttribute('data-selected-options');
            selectedOptions = selectedOptions.split(',').map(Number);
        };

        const hasOptionsCheck = () => {
            selectedOptions = carousel.getAttribute('data-selected-options');
            if (selectedOptions) {
                mainContainer.classList.add(carouselVisibleClass);
            } else {
                mainContainer.classList.remove(carouselVisibleClass);
            }
        };

        const removeFullHeight = () => {
            slides.forEach((slide) => {
                slide.classList.remove(fullHeightClass);
            });
        };

        const adjustCellHeights = () => {
            slides.forEach((slide) => {
                slide.classList.add(fullHeightClass);
            });
        };

        const resizeCarousel = () => {
            hasOptionsCheck();
            removeFullHeight();
            flkty.resize();
            adjustCellHeights();
        };

        optionsTypeDropdown.addEventListener('change', (e) => {
            if (e.detail.value === 'recommended') {
                getRecommendedOptions();
            } else {
                getAllOptions();
                selectedOptions = allOptions;
            }
            updateVisibleOptions(selectedOptions);
        });

        flkty = new Flickity(carousel, {
            imagesLoaded: true,
            cellAlign: 'left',
            groupCells: '100%',
            contain: true,
            draggable: true,
            pageDots: false,
        });

        expandBtns.forEach(btn => btn.addEventListener('e7Toggle', resizeCarousel));

        const observer = new MutationObserver(() => {
            getRecommendedOptions();
            choicesOptionsDropdown.setChoiceByValue('recommended');
            updateVisibleOptions(selectedOptions);
        });

        observer.observe(carousel, {
            attributes: true,
            attributeFilter: ['data-selected-options'],
        });

        updateVisibleOptions = (options) => {
            slides.forEach((slide) => {
                slide.classList.remove(slideVisibleClass);
                slide.classList.remove(selectedClass);
            });

            slides.forEach((slide) => {
                const level = parseInt(slide.getAttribute('data-level'), 10);
                if (options.indexOf(level) !== -1) {
                    slide.classList.add(slideVisibleClass);
                    slide.classList.add(selectedClass);
                }
            });

            flkty.destroy();

            flkty = new Flickity(carousel, {
                imagesLoaded: true,
                cellAlign: 'left',
                groupCells: '100%',
                contain: true,
                draggable: true,
                pageDots: false,
            });

            resizeCarousel();

        };
    }
})();
